// Display names for each form. Kept free of client-only imports (Firebase SDK)
// so server routes and emails can use it; schemas.ts re-exports it.
import { formSlugs } from "@/helpers/utils/form-constants";

export const formNames: Record<string, string> = {
  [formSlugs.techPitchElevateHer]: "ElevateHer Pitch",
  [formSlugs.techPitchCBlack]: "CBlack Pitch",
  [formSlugs.techElevate]: "Tech Elevate Application",
  [formSlugs.techSpeaker]: "Tech Speaker Sign Up",
  [formSlugs.techInvestor]: "Tech Startup Sign Up",
  [formSlugs.techEngineers]: "Tech Engineer Sign Up",
  [formSlugs.techStartupAlpha]: "C-Tribe Startup Alpha",

  [formSlugs.techExecLuncheonGeneralAdmission2k25]:
    "Tech Exec Luncheon General Admission Registration Form",

  [formSlugs.techCBlackSemiFinals]:
    "CBlack Tech Pitch Semi Finals Registration Form",
  [formSlugs.techCElevateHerSemiFinals]:
    "CElevateHer Tech Pitch Semi Finals Registration Form",

  [formSlugs.gamingEsportOverwatch]: "Gaming Pitch Quest",
  [formSlugs.gamingSpeaker]: "Gaming Speaker Sign Up",
  [formSlugs.gamingDeveloper]: "Gaming Developer Sign Up",
  [formSlugs.gamingPitchQuest]: "Gaming Pitch Quest",
  [formSlugs.vendor]: "C-Tribe Village Expo Exhibitor / Partner Application",
  [formSlugs.villageInterest]: "C-Tribe Village Expo Interest and Updates (Not a Ticket)",
  [formSlugs.fashionDesigner]: "Fashion Designer",
  [formSlugs.fashionBuyer]: "Fashion Buyer",
  [formSlugs.fashionStylist]: "Fashion Stylist",
  [formSlugs.fashionMua]: "Fashion MUA",
  [formSlugs.fashionModel]: "Fashion Model",
  [formSlugs.fashionModelNovember2026]: "Fashion Model (February 25, 2027 Show)",
  [formSlugs.fashionDesignerFebruary2027]: "Fashion Designer (February 25, 2027 Show)",
  [formSlugs.fashionPhotographerFebruary2027]: "Photographer (February 25, 2027 Show)",
  [formSlugs.fashionProfessionals]: "Fashion Professionals",
  [formSlugs.fashionExhibit]: "Fashion Exhibit Application",
  [formSlugs.fashionPartner]: "Fashion Partnership Application",
  [formSlugs.resumeUpload]: "Resume Upload",
  [formSlugs.volunteer]: "Volunteer",
  [formSlugs.mediaPress]: "Media & Press Registration",
  [formSlugs.b2b]: "B2B Matchmaking",
  [formSlugs.influencer]: "Creator and Influencer Registration",
  [formSlugs.musicArtist]: "Music Artist",
  [formSlugs.musicPublisher]:
    "Music Publisher's Zone For Artists, Musicians, Performers, Songwriters, and Bands",
  [formSlugs.musicPublisherPublisher]: "Music Publisher's Zone For Publishers",

  [formSlugs.diversityPass]: "Diversity Pass Application Form",
  [formSlugs.generalSpeaker]: "General Speaker Application Form",

  [formSlugs.photographer]: "Photographer Application Form",
  [formSlugs.vipDinner]: "VIP Dinner",
  [formSlugs.innovationZone]: "Innovation Zone Application Form",

  [formSlugs.partnership]: "Partnership Inquiry",
  [formSlugs.film]: "Film Submission",
  [formSlugs.filmSubmission]: "C-Tribe x Film Submission",
  [formSlugs.filmPitch]: "C-Tribe x Film Pitch Meetings",
  [formSlugs.filmIndustry]: "C-Tribe x Film Industry Registration",
  [formSlugs.artist]: "Artist Application",
  [formSlugs.health]: "Health Practitioner Application",
  [formSlugs.videographer]: "Videographer & Photographer Application",
};
